/**
 * Created by michal on 18.05.18.
 */
import './modules/md5';

jQuery(document).ready(function () {
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);

    function rapi(inputmail_value) {
        if (inputmail_value != 0) {
            if (pattern.test(inputmail_value)) {
                var md5 = $.md5('BananowaOchronaAPI24/7mail=' + inputmail_value + '&type=check&value=opp');
                $.getJSON("https://secure.fillup.pl/services/rodo.php", {
                    mail: inputmail_value,
                    type: "check",
                    value: "opp",
                    ref: md5,
                }, function (json_data) {
                    // console.log(JSON.stringify(json_data));

                    if (JSON.stringify(json_data) != "") {
                        if (JSON.stringify(json_data["status"]) == '"OK"') {
                            var json_data = json_data["data"];

                            $(".form-accept-group input[type='checkbox']").prop( "checked", false );

                            if (json_data.length>0) {
                                var data_str = json_data.replace("[","").replace("]","");
                                var data_arr = data_str.split(",");

                                if (data_arr[0]==1) {
                                    $("#accept_service_block").hide();
                                    $("#accept_service_block input[type='checkbox']").prop( "checked", true );
                                } else {
                                    $("#accept_service_block").show();
                                }

                                if (data_arr[1]==1) {
                                    $("#accept_marketing_block").hide();
                                    $("#accept_marketing_block input[type='checkbox']").prop( "checked", true );
                                } else {
                                    $("#accept_marketing_block").show();
                                }

                                if (data_arr[3]==1) {
                                    $("#accept_regulation_block").hide();
                                    $("#accept_regulation_block input[type='checkbox']").prop( "checked", true );
                                } else {
                                    $("#accept_regulation_block").show();
                                }
                            } else {
                                $(".form-accept-group").show();
                            }

                        }
                    }
                });
            } else {
                $(".form-accept-group").hide();
            }
        }
    }

    $(".form-accept-group").hide();


    $('.more-link').on('click', function() {
        $(this).hide();
        $('#data-admin').removeClass('data-hide');
    });


    $("#email").change(function () {
        rapi($(this).val());
    });

    $("#fos_user_registration_form_email").change(function () {
        rapi($(this).val());
    });

    $("#accept_all").change(function () {
        if ($( this ).is( ":checked" ) ) {
            $( ".form-accept-group input[type='checkbox']" ).prop( "checked", true );
        }
    });
});
